import { ColumnsType } from 'rc-table/lib/interface';
import { activityStatusToLocale } from '../../../shared/utils/format';
import { toHumanDate } from '../../../shared/utils/human-date';
import { IPortalActivity, IPortalActivityStatus } from '../../../stores/activity/types';
import { tableCellMore } from '../../components/ui/table/table.columns';
import { Typography } from '../../components/ui/typography';

export const getActivityListColumns = (opts: {
  onMore: (activity: IPortalActivity) => (e: React.MouseEvent<HTMLElement>) => void;
}): ColumnsType<IPortalActivity> => {
  const columns: ColumnsType<IPortalActivity> = [
    {
      title: 'Название',
      width: 200,
      render: (value, record) => <Typography style={{ wordWrap: 'break-word' }}>{record.title}</Typography>,
    },
    {
      title: 'Дата создания/обновления',
      width: 200,
      render: (value, record) => <Typography>{toHumanDate(record.created_at)}</Typography>,
    },
    {
      title: 'Статус',
      width: 200,
      render: (value, record) => <Typography style={{ color: record.status === IPortalActivityStatus.published ? '#73D071' : '#BDBDBD' }}>{activityStatusToLocale(record.status)}</Typography>,
    },
    tableCellMore(opts.onMore),
  ];

  return columns;
};
